import { crm } from "../../../theme";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Flex,
  Heading,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAdd,
  faCheckCircle,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import {
  generateSignUpToken,
  getUsers,
  removeUser,
} from "../../../services/userService";
import { useNavigate } from "react-router-dom";
import { getCompanies } from "../../../services/companyService";
import { useMediaQuery } from "react-responsive";
import { FaPencilAlt, FaPlus, FaTrash, FaUserPlus } from "react-icons/fa";
import { positions } from "../../../models/PurchaseOrder";
import SearchableSelect from "../../../components/SearchableSelect";
import { GenerateSignUpTokenCommand, UserCommand } from "../../../models/User";
import ManageClientsModal from "./ManageClientsModal";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

const AddUsers = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState<UserCommand[]>([]);
  const [filteredUsers, setFilteredUsers] = useState<UserCommand[]>([]);
  const [emails, setEmails] = useState<GenerateSignUpTokenCommand[]>([]);
  const [company, setCompany] = useState<any>([]);
  const [companies, setCompanies] = useState<any[]>([]);
  const auth = useAuthUser<any>();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState<string>();
  const [isAdmin, setIsAdmin] = useState(false);
  const [position, setPosition] = useState(0);
  const [error, setError] = useState<string>();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const get = async () => {
    const response = await getUsers();
    let newUsers = response;

    if (auth.position !== 2) {
      newUsers = newUsers.filter((u: any) => u.position !== 2);
    }
    if (auth.company === "CVF Distribuidora") {
      newUsers = newUsers.filter((u: any) => u.company === "CVF Distribuidora");
    } else if (auth.company === "CVF Logística") {
      newUsers = newUsers.filter((u: any) => u.company === "CVF Logística");
    } else if (auth.company === "CVF Rondônia") {
      newUsers = newUsers.filter((u: any) => u.company === "CVF Rondônia");
    } else if (auth.company === "W Trading") {
      newUsers = newUsers.filter((u: any) => u.company === "W Trading");
    }

    setUsers(newUsers);

    setFilteredUsers(newUsers);
  };

  const remove = async (id: string) => {
    await removeUser(id);
    await get();
  };

  useEffect(() => {
    get();
  }, []);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenUser,
    onOpen: onOpenUser,
    onClose: onCloseUser,
  } = useDisclosure();
  const [user, setUser] = useState<UserCommand>();
  const sendEmails = async () => {
    setLoading(true);
    const response = await generateSignUpToken(
      emails.map((e) => ({
        ...e,
        companyId: company,
      }))
    );
    if (response) {
      onOpen();
    }
    setLoading(false);
  };
  const getCompaniesOptions = async () => {
    const response = await getCompanies(true);
    if (response) setCompanies(response);
  };
  useEffect(() => {
    getCompaniesOptions();
  }, []);
  return (
    <Box>
      <Heading size="lg" mb="24px" fontWeight="normal">
        <Flex alignItems="center" gap="12px">
          <FaUserPlus color="var(--icon-color)" /> Gerenciar usuários
        </Flex>
      </Heading>
      <Box width="100%" backgroundColor="white" borderRadius="12px" border={`1px solid ${crm.border}`} boxShadow={crm.shadowSm} p="24px">
        <Heading size="sm" color={crm.textMuted} fontWeight="600" fontSize="xs" textTransform="uppercase" letterSpacing="0.05em" mb="8px">
          E-mail(s)
        </Heading>
        <Flex flexDirection="column">
          <ButtonGroup>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} />
            <Select
              value={position}
              onChange={(e) => setPosition(parseFloat(e.target.value))}
            >
              {positions.map((p) => (
                <option key={p.key} value={p.key}>
                  {p.label}
                </option>
              ))}
            </Select>
            <Checkbox
              isChecked={isAdmin}
              onChange={(e) => setIsAdmin(e.target.checked)}
            >
              Admin
            </Checkbox>

            <IconButton
              onClick={() => {
                const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const valid = regexEmail.test(email ?? "");
                if (!valid) {
                  setError("E-mail inválido.");
                  return;
                }
                if (emails.some((e) => e.email === email)) {
                  setError("E-mail já adicionado.");
                  return;
                }
                setError("");
                setEmail("");
                setEmails((emails) => [
                  ...emails,
                  {
                    email: email ?? "",
                    admin: isAdmin,
                    position,
                    companyId: "",
                  },
                ]);
              }}
              color="white"
              backgroundColor={crm.brand}
              borderRadius="10px"
              _hover={{ backgroundColor: crm.brandDark }}
              aria-label="add"
              icon={<FaPlus />}
            />
          </ButtonGroup>
          <Flex flexWrap={"wrap"} marginY="8px" gap="16px">
            {emails.map((e) => (
              <Flex
                key={e.email}
                backgroundColor={crm.brand}
                borderColor={crm.brand}
                borderRadius="3px"
                borderWidth="1px"
                gap="8px"
                height="32px"
                padding="4px 8px"
                color="white"
                alignItems="center"
              >
                <Text fontWeight="semibold">
                  {e.email} |{" "}
                  {positions.find((p) => p.key === e.position)?.label}
                  {e.admin ? " | Admin" : ""}
                </Text>
                <FontAwesomeIcon
                  icon={faClose}
                  color="white"
                  onClick={() =>
                    setEmails((emails) => {
                      const newEmails = emails.map((t) => t);
                      newEmails.splice(
                        emails.findIndex((t) => t.email === e.email),
                        1
                      );
                      return newEmails;
                    })
                  }
                />
              </Flex>
            ))}
          </Flex>
          {error && (
            <Text marginTop="16px" color="red">
              {error}
            </Text>
          )}
          <Heading size="sm" fontWeight="normal" mt="24px" marginBottom="8px">
            Empresa
          </Heading>

          <SearchableSelect
            options={companies.map((c) => ({ value: c.id, label: c.name }))}
            value={company}
            setValue={(value) => setCompany(value)}
          />
        </Flex>
        <Modal size="xl" isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalBody>
              <Flex
                alignItems="center"
                flexDirection="column"
                padding="32px"
                gap="32px"
              >
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  color={crm.success}
                  fontSize="80px"
                />
                <Heading textAlign="center">
                  E-mail(s) enviado(s) com sucesso!
                </Heading>
                <ButtonGroup>
                  <Button
                    backgroundColor={crm.brand}
                    color="white"
                    borderRadius="10px"
                    _hover={{ backgroundColor: crm.brandDark }}
                    onClick={() => navigate("/")}
                  >
                    Voltar para o Início
                  </Button>
                  <Button onClick={onClose}>Enviar mais e-mails</Button>
                </ButtonGroup>
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Box>
      <Flex w="100%" justifyContent="flex-end">
        <Button
          marginY="32px"
          backgroundColor={crm.brand}
          color="white"
          borderRadius="10px"
          _hover={{ backgroundColor: crm.brandDark }}
          onClick={() =>
            error?.length === 0 && emails.length > 0 && sendEmails()
          }
          isLoading={loading}
        >
          Enviar e-mails
        </Button>
      </Flex>
      <Input
        placeholder="Pesquise um usuário"
        my="32px"
        height="40px !important"
        onChange={(e) =>
          setFilteredUsers((fs) => {
            const newfs = [...users];
            return newfs.filter(
              (f) =>
                f.firstname
                  ?.toLowerCase()
                  .includes(e.target.value.toLowerCase()) ||
                f.lastname
                  ?.toLowerCase()
                  .includes(e.target.value.toLowerCase()) ||
                f.email?.toLowerCase().includes(e.target.value.toLowerCase()) ||
                f.company?.toLowerCase().includes(e.target.value.toLowerCase())
            );
          })
        }
      />
      <Flex flexDir="column" gap="16px" h="400px" overflowY="auto">
        <Table>
          <Thead bg={crm.subtle}>
            <Tr>
              <Th color={crm.textMuted} textTransform="none" fontSize="sm">Nome</Th>
              <Th color={crm.textMuted} textTransform="none" fontSize="sm">E-mail</Th>
              <Th color={crm.textMuted} textTransform="none" fontSize="sm">Cliente</Th>
              <Th color={crm.textMuted} textTransform="none" fontSize="sm" w="110px">É admin</Th>
              <Th color={crm.textMuted} textTransform="none" fontSize="sm">Cargo</Th>
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredUsers.map((p) => (
              <Tr key={p.id ?? p.email}>
                <Td>
                  <Heading size="sm" fontWeight="normal">
                    {p.firstname} {p.lastname}
                  </Heading>
                </Td>
                <Td>
                  <Heading size="sm" fontWeight="normal">
                    {p.email}
                  </Heading>
                </Td>

                <Td>
                  <Heading size="sm" fontWeight="normal">
                    {p.company}
                  </Heading>
                </Td>

                <Td>
                  <Heading size="sm" fontWeight="normal">
                    {p.admin ? "Sim" : "Não"}
                  </Heading>
                </Td>

                <Td>
                  <Heading size="sm" fontWeight="normal">
                    {
                      positions.find((po) => po.key === (p.position ?? 0))
                        ?.label
                    }
                  </Heading>
                </Td>
                <Td>
                  <Flex gap="12px">
                    <FaPencilAlt
                      color={crm.brand}
                      onClick={() => {
                        setUser(p);
                        onOpenUser();
                      }}
                      cursor="pointer"
                    />
                    <FaTrash
                      color={crm.danger}
                      onClick={() => remove(p.id ?? "")}
                      cursor="pointer"
                    />
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Flex>
      <ManageClientsModal
        isOpen={isOpenUser}
        onClose={onCloseUser}
        user={user}
      />
    </Box>
  );
};

export default AddUsers;
